export default "__VITE_ASSET__79cf69bc__"